import PropTypes from "prop-types"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import OTPInput from "react-otp-input"

const EmailVerificationStep = ({ email, onResend, onActivate, loading, apiError, autoLogin = true }) => {
  const [successMessage, setSuccessMessage] = useState("")
  const [verificationCode, setVerificationCode] = useState("")
  const [validationError, setValidationError] = useState("")

  const resend = async () => {
    setSuccessMessage("")
    const success = await onResend()
    if (success) setSuccessMessage("Un nouveau code de vérification vient de vous être envoyé.")
  }

  const activate = event => {
    event.preventDefault()
    if (!/^\d{6}$/.test(verificationCode)) {
      setValidationError("Saisissez le code de vérification à 6 chiffres.")
      return
    }
    setValidationError("")
    onActivate(verificationCode)
  }

  return (
    <section className="partner-page partner-verification-step">
      <div className="partner-mail-illustration">
        <i className="bx bx-envelope" />
        <span><i className="bx bx-check" /></span>
      </div>
      <h1>Activez votre compte</h1>
      <p className="partner-lead">
        Nous venons d’envoyer un code de vérification à 6 chiffres à <strong>{email}</strong>.
      </p>

      {successMessage && <div className="partner-alert partner-alert-success">{successMessage}</div>}
      {apiError && <div className="partner-alert partner-alert-danger">{apiError}</div>}

      <form className="partner-otp-form" onSubmit={activate}>
        <label>Code de vérification</label>
        <OTPInput
          value={verificationCode}
          onChange={value => {
            setVerificationCode(value)
            setValidationError("")
          }}
          numInputs={6}
          inputType="tel"
          shouldAutoFocus
          renderSeparator={<span />}
          renderInput={props => <input {...props} aria-label="Chiffre du code de vérification" />}
          containerStyle="partner-otp-inputs"
          inputStyle="partner-otp-input"
        />
        {validationError && <div className="partner-field-error">{validationError}</div>}
        <button type="submit" className="partner-button partner-button-primary" disabled={loading || verificationCode.length !== 6}>
          {loading ? <span className="partner-spinner" /> : <i className="bx bx-check-circle" />} Activer mon compte
        </button>
      </form>

      <div className="partner-verification-actions">
        <button type="button" className="partner-button partner-button-secondary" onClick={resend} disabled={loading}>
          <i className="bx bx-refresh" /> Renvoyer le code
        </button>
      </div>
      <Link to="/login" className="partner-login-link"><i className="bx bx-left-arrow-alt" /> Retour à la connexion</Link>
      <p className="partner-security-note"><i className="bx bx-lock-alt" /> {autoLogin ? "Vous serez connecté automatiquement après l’activation." : "Après l’activation, vous pourrez vous connecter avec votre mot de passe."}</p>
    </section>
  )
}

EmailVerificationStep.propTypes = {
  apiError: PropTypes.string,
  autoLogin: PropTypes.bool,
  email: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onActivate: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
}

export default EmailVerificationStep
